export default __webpack_public_path__ + "static/media/BheruSinghLibrary.6326e919.jpg";